import { underscore_restArgs } from './underscore-restargs';

const underscore_delay = underscore_restArgs(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

export { underscore_delay }